import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const header = css`
  width: 100%;
`;

export const svgContainer = css`
  width: 9rem;
  height: 2.15rem;
`;

export const emersonLogo = css`
  height: 2.75rem;
  object-fit: contain;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    height: 4rem;
  }
`;

export const logoWrapper = {
  base: css`
    padding: 1rem;
  `,
  fromCompanyByFullscript: css`
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media (max-width: ${dimensions.phoneLargeMax}) {
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }
  `,
};

export const logo = {
  base: css`
    width: auto;

    @media (max-width: ${dimensions.phoneLargeMax}) {
      margin-top: 1rem;
    }
  `,
  wellevate: css`
    height: 2.15rem;
  `,
  emersonEcologics: css`
    height: 2.75rem;
  `,
};
